import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/(site)/[streamer]/[wishSlug]/layout.tsx");
